import React from 'react';
import EventLabel from '../../components/EventLabel/EventLabel';



export default function TableHeader({ displayConfirmationSettings }) {
  return (
    <tr>
      <th>
        <EventLabel name="Name" groupName="CMS.OrderSummary" />
      </th>
      {displayConfirmationSettings['ShowConfRowStatus'] ? (
        <th>
          <EventLabel name="OrderRowStatus" groupName="CMS.OrderSummary" />
        </th>
      ) : null}
      {displayConfirmationSettings['ShowConfStartDate'] || displayConfirmationSettings['ShowConfStartTime'] ? (
        <th align="left">
          <EventLabel name="StartDateTime" groupName="CMS.OrderSummary" />
        </th>
      ) : null}
      {displayConfirmationSettings['ShowConfEndDate'] || displayConfirmationSettings['ShowConfEndTime'] ? (
        <th align="left" >
          <EventLabel name="EndDateTime" groupName="CMS.OrderSummary" />
        </th>
      ) : null}
      {displayConfirmationSettings['ShowConfAmount'] ? (
        <th align="right" className="text-right">
          <EventLabel name="Amount" groupName="CMS.OrderSummary" />
        </th>
      ) : null}
      {displayConfirmationSettings['ShowConfDiscount'] ? (
        <th align="right" className="text-right">
          <EventLabel name="DiscountAmount" groupName="CMS.OrderSummary" />
        </th>
      ) : null}
      {displayConfirmationSettings['ShowConfVatAmount'] ? (
        <th align="right" className="text-right">
          <EventLabel name="VatAmount" groupName="CMS.OrderSummary" />
        </th>
      ) : null}
      {displayConfirmationSettings['ShowConfVatPercent'] ? (
        <th align="right" className="text-right">
          <EventLabel name="VatPercent" groupName="CMS.OrderSummary" />
        </th>
      ) : null}
      {displayConfirmationSettings['ShowConfQuantity'] ? (
        <th align="right" className="text-right">
          <EventLabel name="Quantity" groupName="CMS.OrderSummary" />
        </th>
      ) : null}
      {displayConfirmationSettings['ShowConfRowTotal'] ? (
        <th align="right"  className="text-right">
          <EventLabel name="RowTotal" groupName="CMS.OrderSummary" />
        </th>
      ) : null}
    </tr>
  );
}
